/* eslint-disable no-undef */
import React, { useState } from "react"
import ReactDOM from 'react-dom/client';
import { InstantSearch,  Configure } from 'react-instantsearch';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import ProductsAccordion from "./typeahead/productsAccordion"
const root = document.querySelector(".accordion-product-properties")

const credentials = ALGOLIA_CREDENTIALS || null
const searchClient = algoliasearch(credentials.appId, credentials.apiKey);

function Typeahead(){
	  const [isActive, setActive] = useState( false );
      return (<div className="product-container">
        <ProductsAccordion isActive={isActive} />
    </div>)
}
if (root ) {
	const root1Element = ReactDOM.createRoot( root );
    const productData = root ? JSON.parse(root.getAttribute("data-productData")) : null
    const entryId = productData.entryId;
 root1Element.render(
        <InstantSearch  searchClient={searchClient} indexName="products">
            <Configure hitsPerPage={1}   facetFilters={[`id:${entryId.toString()}` ]} />
			<Typeahead />
        </InstantSearch>
    )
}